<template>
    <button id="PREV" name="PREV" class="btn" data-vcode="PREV">
        <img src="/images/icons/last.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('prevButton') }}</label>
    </button>
</template>
<script>
export default {};
</script>
